import { IJsonQuery } from '../../../packages/api-models/common/json_query';
import { IApplicationState } from '../../types/redux';

export function selectJsonQuery(state: IApplicationState): IJsonQuery {
  return state.filters.jsonQuery;
}
